import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import queryString from 'query-string';
import FacilitatorLog from 'src/containers/wedding-request/facilitators/facilitatorLog';
import weddingRequestService from 'src/services/api/weddingRequestService';
import AllFacilitatorWeddingRequests from 'src/containers/wedding-request/facilitators/allFacilitatorWeddingRequests';
import styled from '@emotion/styled';
import { adminTableStyles } from 'src/assets/styles/components/AdminTable';
import { changeDocTitle } from 'src/components/helpers';

const WeddingRequestTable = styled('section')`
  ${adminTableStyles}
  .greet {
    font-size: 1.5rem;
    text-align: center;
  }
`;

const WeddingRequestFacilitators = () => {
  const [inputs, setInputs] = useState({});
  const [allWeddingRequests, set_allWeddingRequests] = useState([]);
  const [loading, set_loading] = useState(false);

  const handleInputs = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    setInputs({ ...inputs, [name]: value });
  };

  useEffect(() => {
    changeDocTitle('Solicitudes de Matrimonio');
  }, []);

  let query = window.location.search;
  let parsedQueryString = queryString.parse(query);

  useEffect(() => {
    const { identification, phone } = parsedQueryString;
    if (identification && phone) {
      setInputs({ ...inputs, identification, phone });
    }
  }, []);

  function getInfo(extra = {}) {
    set_loading(true);
    const body = {
      ...parsedQueryString,
      ...inputs,
      ...extra,
    };
    delete body.ac;

    weddingRequestService
      .WeddingRequestsFacilitatorLog(body)
      .then((response) => {
        set_loading(false);
        if (response.data.success) {
          set_allWeddingRequests(response.data.allWeddingRequests);
          setInputs({
            ...inputs,
            ...(response.data.weddingFacilitator || {}),
          });
        }
      })
      .catch((error) => {
        if (error.response) Swal.fire(error.response.data.message);
        set_loading(false);
      });
  }

  return (
    <WeddingRequestTable>
      <h1 style={{ textAlign: 'center' }}>Solicitudes de matrimonio</h1>
      {!inputs?.id ? (
        <FacilitatorLog
          inputs={inputs}
          setInputs={setInputs}
          getInfo={getInfo}
          parsedQueryString={parsedQueryString}
          set_loading={set_loading}
          loading={loading}
          handleInputs={handleInputs}
        />
      ) : (
        <AllFacilitatorWeddingRequests
          allWeddingRequests={allWeddingRequests}
          getInfo={getInfo}
          inputs={inputs}
          loading={loading}
        />
      )}
    </WeddingRequestTable>
  );
};

export default WeddingRequestFacilitators;
